import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { getDatabase, ref, get, update } from 'firebase/database';

const escapeEmail = (email) => email.replace(/\./g, ',');

const ApproveTransfer = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('Verifying transfer request...');
  const [canApprove, setCanApprove] = useState(false);

  useEffect(() => {
    const verifyRequest = async () => {
      const email = searchParams.get('email');
      if (!email) {
        setStatus('Invalid transfer link.');
        return;
      }
      const db = getDatabase();
      const escapedEmail = escapeEmail(email);
      const requestRef = ref(db, `transferRequests/${escapedEmail}`);
      const snapshot = await get(requestRef);
      if (snapshot.exists()) {
        setCanApprove(true);
        setStatus(`Transfer request found for ${email}. Click below to approve.`);
      } else {
        setStatus('No active transfer request found for this email.');
      }
    };
    verifyRequest();
  }, [searchParams]);

  const handleApprove = async () => {
    const email = searchParams.get('email');
    const db = getDatabase();
    const escapedEmail = escapeEmail(email);
    const requestRef = ref(db, `transferRequests/${escapedEmail}`);
    await update(requestRef, { approved: true });
    setStatus('Transfer approved! You can now close this page.');
    setCanApprove(false);
  };

  return (
    <div style={{ padding: '2rem', maxWidth: '600px', margin: '0 auto' }}>
      <h2>Approve Account Transfer</h2>
      <p>{status}</p>
      {canApprove && (
        <button onClick={handleApprove} style={{ padding: '0.5rem 1rem' }}>Approve Transfer</button>
      )}
    </div>
  );
};

export default ApproveTransfer;
